export type ThemePreference = 'dark' | 'light' | 'auto';
export type ResolvedTheme = 'dark' | 'light';

export const THEME_STORAGE_KEY = 'ig-theme-preference';

export function getSystemTheme(): ResolvedTheme {
  if (typeof window === 'undefined') return 'dark';
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function resolveThemePreference(preference: ThemePreference): ResolvedTheme {
  if (preference === 'auto') return getSystemTheme();
  return preference;
}

export function readStoredThemePreference(): ThemePreference | null {
  if (typeof window === 'undefined') return null;
  const raw = window.localStorage.getItem(THEME_STORAGE_KEY);
  if (raw === 'dark' || raw === 'light' || raw === 'auto') return raw;
  return null;
}

export function writeStoredThemePreference(preference: ThemePreference): void {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(THEME_STORAGE_KEY, preference);
}

export function applyResolvedTheme(resolved: ResolvedTheme): void {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;
  root.setAttribute('data-theme', resolved);
  if (resolved === 'dark') {
    root.classList.add('dark');
  } else {
    root.classList.remove('dark');
  }
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) {
    meta.setAttribute('content', resolved === 'dark' ? '#000000' : '#fafaf8');
  }
}

export function applyThemePreference(preference: ThemePreference): ResolvedTheme {
  const resolved = resolveThemePreference(preference);
  applyResolvedTheme(resolved);
  return resolved;
}

/** Apply theme from localStorage before React mounts (FOUC prevention). */
export function initThemeFromStorage(): void {
  const stored = readStoredThemePreference() ?? 'dark';
  writeStoredThemePreference(stored);
  applyThemePreference(stored);
}
